import { useModalStore , modalStateEnum } from '@shared/model'
import { setAuthEntryPoint } from '@shared/lib'


export const useAuthModal = () => {
  const modalStore = useModalStore()

  const openLogin = (source?: string) => {
    if (source) setAuthEntryPoint(source)
    modalStore.setState(modalStateEnum.Login)
  }

  const openRegistration = () => {
    modalStore.setState(modalStateEnum.Registration)
  }

  const openForgotPassword = () => {
    modalStore.setState(modalStateEnum.ForgotPassword)
  }

  const openRestorePassword = () => {
    modalStore.setState(modalStateEnum.RestorePassword)
  }

  const openChangePassword = () => {
    modalStore.setState(modalStateEnum.ChangePassword)
  }

  const closeModal = () => {
    modalStore.close()
  }

  const currentState = computed(() => modalStore.state)
  const isOpen = computed(() => modalStore.isOpen)

  return {
    openLogin,
    openRegistration,
    openForgotPassword,
    openRestorePassword,
    openChangePassword,
    closeModal,
    currentState,
    isOpen,
  }
}
